/**
 * Click a tab, its grid shows. First tab is active on load.
 * Same behaviour at every breakpoint — only the indicator's orientation differs,
 * and that is pure CSS.
 */
class TuProductTabs extends HTMLElement {
  #activeIndex = -1;

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tu-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-tu-panel]'));
    this.shopAll = this.querySelector('[data-tu-shop-all]');

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.handleTabClick = this.handleTabClick.bind(this);
    this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));

    this.setActive(0);
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
  }

  handleTabClick(event) {
    this.setActive(Number(event.currentTarget.dataset.index));
  }

  setActive(index) {
    if (this.#activeIndex === index) return;
    this.#activeIndex = index;

    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-current', String(i === index));
    });

    this.panels.forEach((panel, i) => {
      panel.setAttribute('data-active', String(i === index));
    });

    // Shop all follows the active tab's collection.
    if (this.shopAll) {
      const url = this.tabs[index]?.dataset.shopAllUrl;
      if (url) this.shopAll.setAttribute('href', url);
    }
  }
}

if (!customElements.get('tu-product-tabs')) {
  customElements.define('tu-product-tabs', TuProductTabs);
}